export const convertToCSV = (data) => {
  if (data.length === 0) return "";

  const headers = Object.keys(data[0]);

  const headerRow = headers.join(",");

  const rows = data.map((item) => {
    return headers
      .map((header) => {
        const value = item[header];
        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes('"'))
        ) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      })
      .join(",");
  });

  return [headerRow, ...rows].join("\n");
};

export const formatDdData = (inputData) => {
  if (!Array.isArray(inputData) || inputData.length === 0) {
    return [];
  }

  const result = [];

  for (const item of inputData) {
    // Extract the common properties
    const { ddName, description, configGroup, columnType, ddValues } = item;

    if (!ddValues || !Array.isArray(ddValues)) {
      continue;
    }

    // Create an entry for each ddValue
    for (const ddValue of ddValues) {
      result.push({
        ddName: ddName || "",
        description: description || "",
        configGroupName: configGroup?.name || "",
        columnType: columnType || "",
        ddvalue: ddValue.value || "",
      });
    }
  }

  return result;
};